const demoContent = [
  {
    name: {
      en: 'Overall satisfaction',
      de: 'Gesamtzufriedenheit',
      fr: 'Satisfaction générale',
      it: 'La soddisfazione di tutti',
    },
    values: ['S230_00', 'S240_00'],
  },
  {
    name: {
      en: 'Satisfaction with partial aspects',
      de: 'Zufriedenheit mit Teilsaspekten',
      fr: 'La satisfaction des aspects partiels',
      it: 'La soddisfazione di aspetti parziali',
    },
    groups: [
      {
        name: {
          en: 'Tangibles',
          de: 'Ausstattung',
          fr: 'Tangibles',
          it: 'Tangibile',
        },
        values: ['S10_00', 'S20_00', 'S30_00'],
      },
      {
        name: {
          en: 'Reliability',
          de: 'Zuverlässigkeit',
          fr: 'Fiabilité',
          it: 'Affidabilità',
        },
        values: ['S40_00', 'S50_00', 'S60_00'],
      },
      {
        name: {
          en: 'Responsiveness',
          de: 'Reaktivität',
          fr: 'Réactivité',
          it: 'Reattività',
        },
        values: ['S70_00', 'S80_00'],
      },
      {
        name: {
          en: 'Assurance',
          de: 'Sicherheit',
          fr: 'Assurance',
          it: 'Assicurazione',
        },
        values: ['S90_00', 'S100_00'],
      },
      {
        name: {
          en: 'Empathy',
          de: 'Empathie',
          fr: 'Empathie',
          it: 'Empatia',
        },
        values: ['S110_00', 'S120_00', 'S130_00'],
      },
      {
        name: {
          en: 'Communication',
          de: 'Kommunikation',
          fr: 'Communication',
          it: 'Comunicazione',
        },
        values: ['S140_00', 'S150_00'],
      },
      {
        name: {
          en: 'Functional',
          de: 'Funktionale Aspekte',
          fr: 'Les aspects fonctionnels',
          it: 'Aspetti funzionali',
        },
        values: ['S140_00', 'S150_00', 'S130_00'],
      },
    ],
  },
  {
    name: {
      en: 'Critical incidents',
      de: 'Kritische Vorfälle',
      fr: 'Les incidents critiques',
      it: 'Incidenti critici',
    },
    values: ['S200_00', 'S220_00'],
    isOpenQuestionType: true,
    // groups: [
    //   {
    //     name: {
    //       en: 'Positive',
    //       de: 'Positive de',
    //       fr: 'Positive fr',
    //       it: 'Positive it',
    //     },
    //     values: ['S200_00'],
    //   },
    //   {
    //     name: {
    //       en: 'Negative',
    //       de: 'Negative de',
    //       fr: 'Negative fr',
    //       it: 'Negative it',
    //     },
    //     values: ['S220_00'],
    //   },
    // ],
  },
];

// const customReportGenerator = (reports: any[]) => {
//   const sum = reports.reduce((prev, current) => prev + current.value, 0);
//   const median = sum / reports.length;
//   const positivi = Math.floor(Math.random() * (10 - 5)) + 5;
//   return [
//     {
//       i18n: {
//         en: 'Overall satisfaction',
//         de: 'Gesamtzufriedenheit',
//         fr: 'Satisfaction générale',
//         it: 'La soddisfazione di tutti',
//       },
//       name: 'C_01',
//       value: median,
//     },
//     {
//       i18n: {
//         en: 'Readiness to recommend',
//         de: 'Bereitschaft zur Weiterempfehlung',
//         fr: 'La volonté de recommander',
//         it: 'Disponibilità a raccomandare',
//       },
//       name: 'C_02',
//       value:
//         reports.reduce((prev, current) => {
//           if (current.value > 4) {
//             return prev + current.value;
//           }
//           return prev;
//         }, 0) / reports.length,
//     },
//     {
//       i18n: {
//         en: 'positive incidents',
//         de: 'positive Vorfälle',
//         fr: 'les incidents positifs',
//         it: 'incidenti positivi',
//       },
//       name: 'C_03',
//       value: positivi,
//     },
//     {
//       i18n: {
//         en: 'negative incidents',
//         de: 'negative Vorfälle',
//         fr: 'les incidents négatifs',
//         it: 'incidenti negativi',
//       },
//       name: 'C_04',
//       value: 10 - positivi,
//     },
//   ];
// };

const getDemoData = (reports: any[], intl: 'en' | 'de' | 'fr' | 'it') => {
  const firstQuestions = demoContent.map((data) => {
    // const customReport = customReportGenerator(reports);
    const filtredReport = reports.filter((data) => data.value !== 0);

    return {
      name: data.name[intl],
      groups: data.groups
        ? data.groups.map((group) => ({
            name: group.name[intl],
            values: filtredReport
              .filter((value) => group.values.indexOf(value.name) !== -1)
              .map((value) => ({
                name: value.i18n[intl],
                value: value.value,
              })),
          }))
        : undefined,
      values: data.values
        ? filtredReport
            .filter((value) => data.values.indexOf(value.name) !== -1)
            .map((value) => ({
              name: value.i18n[intl],
              value: value.value,
            }))
        : undefined,
      isOpenQuestionType: data.isOpenQuestionType || false,
    };
  });

  const filter = firstQuestions.filter((set) => {
    if (set.values) {
      return set.values.length > 0;
    }
    if (set.groups) {
      const isEmptyGroup =
        set.groups.reduce(
          (prev, current) => prev + current.values.length,
          0
        ) === 0;
      return !isEmptyGroup;
    }

    return true;
  });
  return filter;
};

export default getDemoData;
